export const marginLeft = 15;
export const animationTimeout = 2000;
